import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { catchError, throwError } from 'rxjs';
import { TelemetryService } from '../telemetry/telemetry.service';
import { isOwnApiUrl } from './api-token-recovery.interceptor';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const telemetry = inject(TelemetryService);
  const msal = inject(MsalService, { optional: true });

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      telemetry.trackException(error, { url: req.url, method: req.method });

      if (error.status === 401 && !(isOwnApiUrl(req.url) && msal?.instance.getActiveAccount())) {
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
